const formatShippingMethod = method => {
  let formatted = 'Standard'

  switch (method) {
    case 'Ground': formatted = 'Standard'
      break
    case '2 Day': formatted = '2nd Business Day'
      break
    case 'Overnight': formatted = 'Next Business Day'
      break
    case 'Economy': formatted = 'Economy'
      break
    default:
      break
  }

  return formatted
}

const formatShippingMethodV2 = (method, variation, config) => {
  if (method === 'Ground' || method === 'Ground_unfolded') {
    const label = config?.label?.variations.find(v => v.variationValue === variation)
    if (label && method === 'Ground' && label?.foldedLabel) {
      // disable for now
      // return label.foldedLabel
      return 'Standard'
    }

    if (label && method === 'Ground_unfolded' && label?.unfoldedLabel) {
      // disable for now
      // return label.unfoldedLabel
      return 'Standard'
    }

    return method
  }

  let formatted = 'Standard'

  switch (method) {
    case 'Ground': formatted = 'Standard'
      break
    case '2 Day': formatted = '2nd Business Day'
      break
    case 'Overnight': formatted = 'Next Business Day'
      break
    case 'Economy': formatted = 'Economy'
      break
    default:
      break
  }

  return formatted
}

const arrangeShippingMethods = shippingOptions => {
  const sequence = ['Economy', 'Ground', 'Ground_unfolded', '2 Day', 'Overnight']
  const arrangedShipMethods = []

  sequence.forEach(sm => {
    const hasSM = shippingOptions.find(currentSM => currentSM.method === sm)
    if (hasSM) arrangedShipMethods.push(hasSM)
  })

  return arrangedShipMethods
}

export { formatShippingMethod, formatShippingMethodV2, arrangeShippingMethods }
